module.exports = __webpack_public_path__ + "img/tepmplate_malek_essaghir_modifed.54c626b6.png";